import { createBrowserRouter, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import LandingPage from './pages/LandingPage'
import CareersPage from './pages/CareersPage'
import HomePage from './pages/HomePage'
import { ResearchEngineer, ProductEngineer, AnythingElse } from './pages/JobDescription'
import HelpdeskPage from './pages/HomePage'
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import PlaygroundPage from './pages/PlaygroundPage';

// Component for external redirects
const ExternalRedirect: React.FC<{ to: string }> = ({ to }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  
  return <div>Redirecting...</div>;
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <HomePage/>,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/whitepaper',
    element: <Navigate to="/syntra_whitepaper.pdf" replace />,
  },
  {
    path: '/demo',
    element: <ExternalRedirect to="https://zcal.co/t/syntra/demo" />,
  },
  {
    path: '/careers/research-engineer',
    element: <ResearchEngineer />,
  },
  {
    path: '/careers/product-engineer',
    element: <ProductEngineer />,
  },
  {
    path: '/careers/anything-else',
    element: <AnythingElse />,
  },
  {
    path: '/helpdesk',
    element: <HelpdeskPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/deepfake',
    element: <PlaygroundPage />,
  },
]) 